/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const GenericBank: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='#fff' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          fill='#F0F0F0'
        />
        <g clipPath='url(#genericbank-v2-a)'>
          <path d='M25.5 16.5H25v-4h-1v4h-2v-4h-1v4h-2v-4h-1v4h-2v-4h-1v4h-.5a.5.5 0 1 0 0 1h11a.5.5 0 1 0 0-1Zm.24-7.44-5.5-3a.5.5 0 0 0-.48 0l-5.5 3a.5.5 0 0 0-.26.44V11c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V9.5a.5.5 0 0 0-.26-.44ZM20 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z' />
        </g>
        <defs>
          <clipPath id='genericbank-v2-a'>
            <path fill='#fff' transform='translate(14 6)' d='M0 0h12v12H0z' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='#fff' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
        />
        <g clipPath='url(#genericbank-v1-a)'>
          <path d='M25.5 16.5H25v-4h-1v4h-2v-4h-1v4h-2v-4h-1v4h-2v-4h-1v4h-.5a.5.5 0 1 0 0 1h11a.5.5 0 1 0 0-1Zm.24-7.44-5.5-3a.5.5 0 0 0-.48 0l-5.5 3a.5.5 0 0 0-.26.44V11c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V9.5a.5.5 0 0 0-.26-.44ZM20 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z' />
        </g>
        <defs>
          <clipPath id='genericbank-v1-a'>
            <path fill='#fff' transform='translate(14 6)' d='M0 0h12v12H0z' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
